export default __webpack_public_path__ + "static/media/ic_user_white.c43f3477.svg";